import { Button } from "../ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";

type ReviewQueueBulkActionsProps = {
  busy?: boolean;
  selectedCount: number;
  totalCount: number;
  onApprove: () => void;
  onReject: () => void;
  onClear: () => void;
};

export function ReviewQueueBulkActions({
  busy = false,
  selectedCount,
  totalCount,
  onApprove,
  onReject,
  onClear,
}: ReviewQueueBulkActionsProps) {
  return (
    <Card className="border-border bg-card/60">
      <CardHeader className="space-y-1">
        <CardTitle className="text-lg">Bulk actions</CardTitle>
        <CardDescription>
          Selected: {selectedCount} of {totalCount}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-2">
        <Button
          className="w-full sm:w-auto"
          onClick={onApprove}
          disabled={busy || selectedCount === 0}
        >
          Approve selected
        </Button>
        <Button
          variant="outline"
          className="w-full sm:w-auto"
          onClick={onReject}
          disabled={busy || selectedCount === 0}
        >
          Reject selected
        </Button>
        <Button
          variant="ghost"
          className="w-full sm:w-auto"
          onClick={onClear}
          disabled={busy || selectedCount === 0}
        >
          Clear selection
        </Button>
      </CardContent>
    </Card>
  );
}
